<template>
    <div class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="$util.reback('/TouchScreen')" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
                {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-picture-fill"></i>  内容基本信息
            </div>
        </div>
        <el-form ref="ruleForm" :model="form" label-width="130px" :rules="rules" class="flex align-cen">
               <el-form-item label="内容名称：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入内容名称【1-30】" clearable></el-input>
                </el-form-item>
            <el-form-item label="排序：" >
                    <el-input v-model="form.sort" placeholder="请输入内容排序" clearable></el-input>
                </el-form-item>
                  <el-form-item label="模版选择：" prop="template">
                    <el-select
                        v-model="form.template"
                        placeholder="请选择"
                        class="flex"
                    >
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
        </el-form>
          <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-picture-fill"></i>  上传内容
            </div>
            <div class="mft public-btn-small">
                     <div class="public-btn-small-primary" @click="addPiece">
                        上传内容         
                    </div>
                </div>
        </div>
        <div class="pieceBox flex" v-if="form.template == 1">
            <div class="piece-item " v-for="(item,index) in form.screensList" :class="getClassesForIndex(index)">
                <img :src="item.logo" alt="" v-if="item.logo">
                <div v-else class="imgReserve">
                    <i class="el-icon-picture"></i>
                </div>
                <div class="piece-item-mask">
                    <div class="mask-zz">
                        <i class="el-icon-edit" @click="openDetail(form,index)"></i>
                        <i class="el-icon-delete" @click="deletPiece(index,1)"></i>
                    </div>
                </div>
            </div>
        </div>
          <div class="pieceBox pieceBox1" v-if="form.template == 2">
            <div class="pieceBox1-imgs flex align-cen">
                <div class="pieceBox1-imgs-item" v-for="(item,index) in screensList1">
                    <img :src="item.logo" alt="" v-if="item.logo">
                        <div v-else class="item-imgReserve">
                            <i class="el-icon-picture"></i>
                        </div>
                         <div class="piece-item-mask1">
                            <div class="mask-zz1">
                                <i class="el-icon-edit" @click="openDetail1(form,screensList1,index)"></i>
                                <i class="el-icon-delete" @click="deletPiece(index,2)"></i>
                            </div>
                        </div>
                        </div>
            <!-- <div class="swiper-container" v-if="screensList1.length">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item,index) in screensList1">
                        <img :src="item.logo" alt="" v-if="item.logo">
                        <div class="swiper-slide-mask">
                             <div class="mask-zz">
                                <span>{{index}}</span>
                                <i class="el-icon-edit" @click="openDetail(form,index)"></i>
                                <i class="el-icon-delete" @click="deletPiece(index,2)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                   <div class="swiper-button-next arrow" slot="button-next">
                     <span class="el-icon-caret-right"></span>
                   </div> 
                         <div class="swiper-button-prev arrow arrow1" slot="button-prev">
                   <span class="el-icon-caret-left"></span>
                         </div>
            </div> -->
                <!-- <swiper :options="swiperOptions">
                    <swiper-slide>Slide 1</swiper-slide>
                    <swiper-slide>Slide 2</swiper-slide>
                    <swiper-slide>Slide 3</swiper-slide>
                     <swiper-slide>Slide 4</swiper-slide>
                     <swiper-slide>Slide 5</swiper-slide>
                     <swiper-slide>Slide 6</swiper-slide>
                     <swiper-slide>Slide 7</swiper-slide>
                      <swiper-slide>Slide 8</swiper-slide>
                       <swiper-slide>Slide 9</swiper-slide>
                       <div class="swiper-button-next"></div>
                         <div class="swiper-button-prev"></div>
                </swiper> -->
            </div>
          </div>
             </div>
    </div>
</template>
<script>
import {editTouch,getTouch} from "@/api/index/index"   //新增编辑触摸内容、内容详情
// import { Swiper, SwiperSlide,Navigation} from 'swiper';
// import 'swiper/swiper-bundle.css'
// Swiper.use([Navigation])
export default {
    name:'addTouch',
//      components: {
//     Swiper,
//     SwiperSlide,
//   },
    data() {
        return {
            swiper:{},
            loading:false,
            emitList:{},
            form:{
                name:'',
                template:'',
                sort:'',
                screensList:[
                ]
            },
            screensList1:[],
            options:[{
                id:'1',
                name:'竖屏模版',
            },{
                id:'2',
                name:'横屏模版'
            }],
            rules:{
                  name: [
                     {
                        trigger: "blur",
                        message:'请输入触摸屏内容名称',
                        required: true, 
                     },
                      { min: 1, max: 30, message: '超出长度', trigger: 'blur' }
                 ],
                 template:[{ trigger: "change", message:'请选择模版', required: true,}]
             }
        }
    },
    mounted(){
            //                  this.$nextTick(() => {
            //              this.swiper = new Swiper(".swiper-container", {
            //     slidesPerView: 3.5,
            //     spaceBetween: 10,
            //     navigation: {
            //     nextEl: ".swiper-button-next",
            //     prevEl: ".swiper-button-prev",
            //     },
            //  });
            //          })
    },
    created () {
       if(this.$route.query.id && !this.$route.query.parms) this.getTouchDetail()
       if(this.$route.query.parms){
            let decryptQuery=this.$base64.decode(this.$route.query.parms); // 解密
            let decryptQuery1
            if(this.$route.query.arr) decryptQuery1=this.$base64.decode(this.$route.query.arr); // 解密
            this.form = JSON.parse(decryptQuery)
            if(this.form.template == 2) this.screensList1 = JSON.parse(decryptQuery1)
            // if(this.form.template == 2) this.screensList1 = JSON.parse(decryptQuery1)
            // console.log()
       }
    },
    methods: {
        // 切换模版
        // switchPeo(){
        //  if(!this.$route.query.id && this.form.template == 2){

        //  }
        // },
        // 打开内容详情
        openDetail(data,index){
            this.$router.push(
            {
            name:'touchDetail',
             query:{
                index:index,
                id: this.$route.query.id ? this.$base64.encode(JSON.stringify(this.$route.query.id)) :  '',
                parms:this.$base64.encode(JSON.stringify(data)) //加密参数
            }
            }
            )
        },
         // 打开内容详情
        openDetail1(data,arr,index){
            this.$router.push(
            {
            name:'touchDetail1',
             query:{
                index:index,
                id: this.$route.query.id ? this.$base64.encode(JSON.stringify(this.$route.query.id)) :  '',
                parms:this.$base64.encode(JSON.stringify(data)), //加密参数
                arr:this.$base64.encode(JSON.stringify(arr))
            }
            }
            )
        },
        // 获取内容详情
         getTouchDetail(){
            getTouch({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                name:res.data.name,
                sort:res.data.sort,
                template:res.data.template,
                screensList:res.data.template == 1 ? res.data.screensList : [],
                }
                if(res.data.template == 2) this.screensList1 = res.data.screensList
            })
            .catch(err =>{})
        },
        // 保存
         onSubmit(formName){
             let method = "post"
             let params = {}
             if(this.form.template == 2) this.form.screensList = this.screensList1
             if(!this.$route.query.id) params = {...this.form},method = "post";
             if(this.$route.query.id) params = {...this.form,id:this.$route.query.id},method = "put";
             this.$refs[formName].validate((valid) => { 
                if(valid){
                     this.commentBness(params,method)
                }
              })
         },
        //  新增编辑共用方法
        commentBness(params,method){
            this.loading = true
             editTouch(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id)  this.$util.Notifi('新增成功','success','fa-check'); 
                           if(this.$route.query.id) this.$util.Notifi('修改成功','success','fa-check');
                                setTimeout(() => {
                           this.$router.push("/TouchScreen")
                             }, 100);
                           }else{
                             this.loading = false
                            this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
        // 删除快
        deletPiece(index,type){
              this.$confirm('确认删除此项吗？删除后不可恢复，请谨慎删除。', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            let delet 
            if(type == 1){
                 delet= this.form.screensList.filter((item,sy)=> sy != index) 
                 this.form.screensList = delet
            }else{
                delet= this.screensList1.filter((item,sy)=> sy != index) 
                 this.screensList1 = delet 
            }
       
        })
        },
        // 根据索引展示不同样式
        getClassesForIndex(index){
            let classes = ''
             if (((index + 1) - 6) % 13 === 0) {
                
                    classes = `special-style-1`;
                }
              if(((index + 1) - 13) % 13 === 0){
                 classes = 'special-style-2';
              }
             return classes;
        },
        // 添加内容块
        addPiece(){
            if(!this.form.template) return this.$util.Notifi('请先选择内容模版','error','fa-exclamation-circle');
             if(this.form.template == 1){
                this.form.screensList.push(({
                logo:'',
                contentType:'',
                websiteType:'',
                detailId:'',
                contentList:[]
            }))
             }else{
                this.screensList1.push(({
                            logo:'',
                            contentType:'',
                            websiteType:'',
                            detailId:'',
                            contentList:[]
                 }))
             }
        },
    },

}
</script>
<style lang="scss" scoped>
  .edit-from{
        margin-bottom: 44px;
        .pieceBox{
            max-width: 1500px;
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 285px;
                    max-height: 110px;
                    display: inline-block;
                     position: relative;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
             
                   .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 110px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 110px;
                        width: calc(100% - 15px);
                        max-width: 285px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 110px;
                            padding-right: 20px;
                        }
                    }
                }
            }
               .piece-item:hover{
                    .piece-item-mask{
                        display: block;
                    }
                }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 585px;
                    max-height: 110px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                  .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 110px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 110px;
                        width: calc(100% - 15px);
                        max-width: 585px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 110px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 585px;
                    max-height: 110px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 110px;
                    text-align: center;
                    line-height: 110px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                   .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 110px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 110px;
                        width: calc(100% - 15px);
                        max-width: 585px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 110px;
                            padding-right: 20px;
                        }
                    }
                }
            }
        }
        .pieceBox1{
            width: 100%;
            // background: url("../../../../assets/images/peopleBg.png") no-repeat 0 0;
            // background-size: 100% 100%;
            max-width: none !important;
            margin-top: 20px;
            padding-top: 0 !important;
            position: relative;
            .pieceBox1-imgs{
                max-width: 1400px;
               margin: 0 auto;
                flex-wrap: wrap;
                .pieceBox1-imgs-item{
                    width: 328px;
                    height: 440px;
                    margin-right: 20px;
                    position: relative;
                    cursor: pointer;
                    margin-bottom: 20px;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .item-imgReserve{
                        width: 100%;
                        height: 100%;
                        background: #f7f8fa;
                        height: 440px;
                        text-align: center;
                        line-height: 440px;
                        i{
                          color: #dcdee0;
                            font-size: 32px;  
                        }
                    }
                    .piece-item-mask1{
                    width: 100%;
                    position: absolute;
                    height: 440px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz1{
                        height: 440px;
                        width: 100%;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 440px;
                            padding-right: 20px;
                        }
                    }
                }

                }
                .pieceBox1-imgs-item:hover{
                    .piece-item-mask1{
                        display: block;
                    }
                }
               
            }
        }
            .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
       .el-input-group{
            width: 80%;
        }
         .el-select{
            width: 170px;
         }
        .el-textarea{
            width: 50%;
        }
        }
               .el-ipt-quill{
            width: 100% !important;
        }
         }
        .App-tab{
            margin: 20px 0;
            
        }
    }
    @media (min-width: 1920px) {
        .pieceBox{
            max-width: 2000px;
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            // justify-content: space-between;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 385px;
                    max-height: 200px;
                    display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                   .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 200px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 200px;
                        width: calc(100% - 15px);
                        max-width: 385px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 200px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 785px;
                    max-height: 200px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                    .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 200px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 200px;
                        width: calc(100% - 15px);
                        max-width: 785px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 200px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-width: 785px;
                    max-height: 200px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 200px;
                    text-align: center;
                    line-height: 200px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                 .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 200px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 200px;
                        width: calc(100% - 15px);
                        max-width: 785px;
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 200px;
                            padding-right: 20px;
                        }
                    }
                }
            }
        }
    }
    @media (min-width: 3000px) {
         .pieceBox{
            margin: 0 auto;
            flex-wrap: wrap;
            padding-top: 15px;
            .piece-item{
                padding-bottom: 15px;
                width: 20%;
                text-align: center;
                position: relative;
                img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                    display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                   
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                 .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 300px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 300px;
                        width: calc(100% - 15px);
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 300px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-1{
                width: 40%;
                 text-align: center;
                   img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                     .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 300px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 300px;
                        width: calc(100% - 15px);
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 300px;
                            padding-right: 20px;
                        }
                    }
                }
            }
            .special-style-2{
                 width: 40%;
                 text-align: center;
                    img,.imgReserve{
                    vertical-align: middle;
                    width: calc(100% - 15px);
                    max-height: 300px;
                     display: inline-block;
                }
                .imgReserve{
                    background: #f7f8fa;
                    height: 300px;
                    text-align: center;
                    line-height: 300px;
                    i{
                        color: #dcdee0;
                        font-size: 32px;
                    }
                }
                     .piece-item-mask{
                    width: 100%;
                    position: absolute;
                    height: 300px;
                    top: 0;
                    left: 0;
                    text-align: center;
                     display: none;
                    .mask-zz{
                        height: 300px;
                        width: calc(100% - 15px);
                        display: inline-block;
                        background: rgba(0,0,0,.5);
                        cursor: pointer;
                       
                        i{
                            color: #fff;
                            font-size: 25px;
                            line-height: 300px;
                            padding-right: 20px;
                        }
                    }
                }
            }
        }
    }
</style>